const BRAND_RX = /\b(GoHighLevel|Go High Level|HighLevel|LeadConnector|GHL)\b/gi;
const PHRASES = [
  [/\b(de|en|con|a)\s+(GoHighLevel|HighLevel|LeadConnector|GHL)\b/gi, "$1 la plataforma"],
  [/X-GHL-Signature/g, "del webhook"],
];

export const brand = (text) => {
  if (typeof text !== "string") return text;
  let out = text;
  PHRASES.forEach(([rx, rep]) => { out = out.replace(rx, rep); });
  return out.replace(BRAND_RX, "Plataforma de mensajería");
};
